<template>

    <div v-if="isLog" class="auth">
        <div v-if="media > 992" class="auth__office d-flex">
<!--            <a href="http://journal.saveus.by/spravka" class="auth__office-link auth__office-link&#45;&#45;toggle-size" target="_blank">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="7.45" stroke="#929292" stroke-width="1.1"/>
                    <path d="M7.89857 5.14493C7.67554 5.14493 7.48645 5.07425 7.3313 4.93288C7.18585 4.78142 7.11312 4.59461 7.11312 4.37247C7.11312 4.15032 7.18585 3.96857 7.3313 3.8272C7.48645 3.67574 7.67554 3.60001 7.89857 3.60001C8.1216 3.60001 8.30585 3.67574 8.4513 3.8272C8.60645 3.96857 8.68403 4.15032 8.68403 4.37247C8.68403 4.59461 8.60645 4.78142 8.4513 4.93288C8.30585 5.07425 8.1216 5.14493 7.89857 5.14493ZM6.40039 11.5973H7.50585V7.25026H6.41494V6.44751H8.56766V11.5973H9.60039V12.4H6.40039V11.5973Z" fill="#929292"/>
                </svg>
            </a>-->
            <Notice />
<!--            <Messages :data="messages"  />-->
            <user/>
        </div>
        <mobile-bar v-else :messages="messages"></mobile-bar>

    </div>
    <div v-else  class="auth">
        <div class="auth__login">
            <a v-if="media > 992" href="/auth/login" class="auth__login-btn">{{$store.getters.t('main_menu_login')}}</a>
            <a v-else href="/auth/login" class="auth__login-btn auth__login-btn--mobile">
                <span class="auth__login-icon">
                      <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.6882 6.29412C17.6882 9.21798 15.318 11.5882 12.3941 11.5882C9.47026 11.5882 7.1 9.21798 7.1 6.29412C7.1 3.37026 9.47026 1 12.3941 1C15.318 1 17.6882 3.37026 17.6882 6.29412ZM8.37431 6.29412C8.37431 8.51419 10.174 10.3139 12.3941 10.3139C14.6142 10.3139 16.4139 8.51419 16.4139 6.29412C16.4139 4.07404 14.6142 2.27432 12.3941 2.27432C10.174 2.27432 8.37431 4.07404 8.37431 6.29412Z" fill="currentColor"/>
                        <path d="M3.65 15.8684C3.65 14.2643 5.26587 13.078 6.93226 13.4881C10.7946 14.4385 14.0311 14.4124 17.9318 13.4505C19.5786 13.0444 21.1735 14.2232 21.1735 15.8186V20.3499H3.65V15.8684Z" stroke="currentColor" stroke-width="1.3"/>
                      </svg>
                </span>
            </a>
        </div>
    </div>

</template>

<script>
    import Notice from './Notice';
    import Messages from './Messages';
    import User from './User';
    import MobileBar from './MobileBar';
    export default {
        props:['isLog','media'],
        components:{
            MobileBar,
            Notice,
            Messages,
            User
        },
        data(){
            return {
                messages : [
                    {
                        id: 1,
                        f_name: 'Алина',
                        l_name: 'Петрова',
                        date: 'Сейчас',
                        thumb: '',
                        text: 'Привет, как обстоят дела с кормом для Привет, как обстоят дела с кормом для',
                        link: '#',
                        newMessage: false,
                    },
                ]
            }
        },

        created(){},
        destroyed(){},

        mounted() {},
        methods:{}


    }

</script>

<style lang="scss" scoped>
    @import '../../../sass/helpers';
    .auth{
        font-size: 14px;
        &__login-btn{
            display: inline-block;
            width: 100%;
            max-width: 175px;
            background-color: $primaryBlue;
            color: white;
            font-size: inherit;
            text-decoration: none;
            padding: 12px 30px;
            border-radius: 20px;
            text-transform: uppercase;
            font-weight: 700;
            transition: background-color .2s ease;
            &:hover{
                background-color: #6C4DBB;
            }
        }


        @media screen and (max-width: 1200px) {
            &__login-btn{
                padding: 12px 20px;
                font-size: 13px;
            }
        }

        @media screen and (max-width: 1200px) {
            &__login-btn{

                &--mobile{
                    padding: 12px 20px;
                    padding-right: 0;
                    background: transparent;
                    color: transparent;
                    font-size: 0;

                    .auth__login-icon{
                        display: block;
                        width: 25px;
                        height: 25px;
                    }

                    &:hover{
                        background: transparent;

/*                        .auth__login-icon{
                            background-image: url("/images/user-active.svg");
                        }*/
                    }
                }

            }


        }

        @media screen and (max-width: 992px){
            .auth__login-btn{
                color: #929292;
                transition: color .2s ease;
                &:hover{
                    color: $primaryBlue;
                }
            }
        }


        @media screen and (max-width: 768px){
            &__login-btn{
                &--mobile{
                    padding: 12px 5px;
                }
            }
        }


    }



</style>
